import React from "react";
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  VStack,
  Button,
  Text,
  Box,
  Divider,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useTournament } from "../contexts/TournamentContext";

const NavigationDrawer = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { basePath, readOnly } = useTournament();

  const navigationItems = [
    { label: readOnly ? "2025 Home" : "Home", href: basePath || "/" },
    { label: "Leaderboard", href: `${basePath}/leaderboard` },
    { label: "Live Scoring", href: `${basePath}/live-scoring` },
    { label: "Players", href: `${basePath}/players` },
    { label: "Pool", href: `${basePath}/golf-pool` },
    ...(readOnly
      ? [{ label: "AR 2026", href: "/" }]
      : [
          { label: "Past Winners", href: "/past-winners" },
          { label: "AR 2025 Archive", href: "/2025" },
          { label: "About", href: "/the-cause" },
        ]),
  ];

  const handleNavigation = (href) => {
    navigate(href);
    onClose();
  };

  const handleLogout = async () => {
    try {
      await logout();
      onClose();
      navigate(basePath || "/");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  const handleLogin = () => {
    navigate("/login");
    onClose();
  };

  return (
    <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent bg="green.800" color="white">
        <DrawerCloseButton />
        <DrawerHeader
          borderBottomWidth="1px"
          fontFamily="Benton Sans"
          fontWeight="400"
        >
          Menu
        </DrawerHeader>
        <DrawerBody>
          <VStack spacing={4} align="stretch" height="100%">
            <VStack spacing={4} align="stretch" flex="1">
              {navigationItems.map((item) => (
                <Button
                  key={item.label}
                  variant="ghost"
                  justifyContent="flex-start"
                  w="full"
                  color="white"
                  _hover={{ bg: "green.700" }}
                  onClick={() => handleNavigation(item.href)}
                  fontFamily="Benton Sans"
                  fontWeight="400"
                  textTransform="none"
                  letterSpacing="normal"
                >
                  {item.label}
                </Button>
              ))}
            </VStack>

            {!readOnly && (
              <Box mt="auto">
                <Divider borderColor="green.600" mb={4} />
                {user ? (
                  <VStack spacing={3} align="stretch">
                    <Box>
                      <Text
                        fontSize="sm"
                        color="green.200"
                        fontFamily="Benton Sans"
                        mb={1}
                      >
                        Logged in as:
                      </Text>
                      <Text
                        fontSize="md"
                        fontFamily="Benton Sans"
                        fontWeight="500"
                      >
                        {user.displayName || user.email}
                      </Text>
                    </Box>
                    <Button
                      variant="outline"
                      colorScheme="white"
                      size="sm"
                      onClick={handleLogout}
                      fontFamily="Benton Sans"
                      fontWeight="400"
                      textTransform="none"
                      letterSpacing="normal"
                    >
                      Logout
                    </Button>
                  </VStack>
                ) : (
                  <Button
                    variant="outline"
                    colorScheme="white"
                    size="sm"
                    onClick={handleLogin}
                    fontFamily="Benton Sans"
                    fontWeight="400"
                    textTransform="none"
                    letterSpacing="normal"
                    w="full"
                  >
                    Login
                  </Button>
                )}
              </Box>
            )}
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default NavigationDrawer;
